import { render, staticRenderFns } from "./CustonCheckbox.vue?vue&type=template&id=1ee4caac&scoped=true&"
import script from "./CustonCheckbox.vue?vue&type=script&lang=js&"
export * from "./CustonCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CustonCheckbox.vue?vue&type=style&index=0&id=1ee4caac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee4caac",
  null
  
)

export default component.exports